"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LinkProps_1 = require("../../../../atoms/Link/LinkProps");
var footerLinksData = {
    copyrightLink: {
        content: '©2018 AT&T Intellectual Property.',
        href: 'https://www.att.com/gen/privacy-policy?pid=2587',
        target: LinkProps_1.TargetType.BLANK,
    },
    links: [
        {
            content: 'Legal policy center',
            href: 'https://www.att.com/legal/legal-policy-center.html',
            target: LinkProps_1.TargetType.BLANK,
        },
        {
            content: 'Privacy policy',
            href: 'http://about.att.com/sites/privacy_policy',
            target: LinkProps_1.TargetType.BLANK,
        },
        {
            content: 'Terms of use',
            href: 'https://www.att.com/legal/terms.attWebsiteTermsOfUse.html',
            target: LinkProps_1.TargetType.BLANK,
        },
        {
            content: 'Broadband details',
            href: 'https://www.att.com/gen/public-affairs?pid=20879',
            target: LinkProps_1.TargetType.BLANK,
        },
        {
            content: 'Advertising choices',
            href: 'http://www.att.com/internal/adchoices',
            target: LinkProps_1.TargetType.BLANK,
        },
        {
            content: 'Accessibility',
            href: 'https://www.att.com/shop/wireless/mobile-accessibility.html',
            target: LinkProps_1.TargetType.BLANK,
        },
        {
            content: 'Sitemap',
            href: 'https://www.att.com/sitemap/',
            target: LinkProps_1.TargetType.BLANK,
        },
    ],
    trusteLink: {
        content: 'TRUSTe privacy certification',
        href: '//privacy.truste.com/privacy-seal/validation?rid=6a62df46-069b-45ec-8768-f516726eb8f6',
        target: LinkProps_1.TargetType.BLANK,
    },
    trusteLogo: '//privacy-policy.truste.com/privacy-seal/seal?rid=6a62df46-069b-45ec-8768-f516726eb8f6',
};
exports.default = footerLinksData;
//# sourceMappingURL=FooterLinksDataContent.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/global/GlobalFooter/cards/FooterLinks/FooterLinksDataContent.js
// module id = 1385
// module chunks = 8